<template>
  <v-container>
    <v-alert dense type="warning">Ten cuidado en esta área ya que el proceso de borrado de datos es irreversible. Aquí no funciona el Ctrl + Z</v-alert>
    <v-form ref="eraserFrm" lazy-validation @submit.prevent="borrar" v-model="eraser.valid">
      <v-row dense>
        <v-col cols="4">
          <v-select
            label="Carga"
            :items="cargas"
            v-model="eraser.carga"
            item-text="name"
            item-value="id"
            :rules="rules"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-dialog
            ref="fecha_inicio"
            v-model="eraser.modal1"
            :return-value.sync="eraser.fecha_inicio"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="eraser.fecha_inicio"
                label="Fecha inicio"
                outlined
                readonly
                hide-details
                :rules="rules"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="eraser.fecha_inicio" scrollable :max="eraser.fecha_fin">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="eraser.modal1 = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.fecha_inicio.save(eraser.fecha_inicio)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="4">
          <v-dialog
            ref="fecha_fin"
            v-model="eraser.modal2"
            :return-value.sync="eraser.fecha_fin"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="eraser.fecha_fin"
                label="Fecha fin"
                outlined
                readonly
                hide-details
                :rules="rules"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="eraser.fecha_fin"
              scrollable
              :max="today"
              :min="eraser.fecha_inicio"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="eraser.modal2 = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.fecha_fin.save(eraser.fecha_fin)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col class="text-right">
          <v-btn
            type="submit"
            color="primary"
            :disabled="!eraser.valid"
            :loading="eraser.loading"
          >Borrar Data</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { Auth } from "../../../../classes/Auth";
import { API } from "../../../../globals";
import { apiv1 } from "../../../../libs/apiv1";

import { apiPython } from '../../../../libs/api.python'

const auth = new Auth();
const today = moment().format("YYYY-MM-DD HH:mm:ss");

export default Vue.extend({
  name: "Eraser",
  data: () => ({
    rules: [v => !!v || "Este campo es obligatorio"],
    cargas: [],
    today: today,
    eraser: {
      valid: true,
      loading: false,
      modal1: null,
      modal2: null,
      fecha_inicio: "",
      fecha_fin: "",
      carga: ""
    }
  }),
  mounted() {
    this.getCargas();
  },
  methods: {
    getCargas: function() {
      apiv1
        .get(`cargas?project=${auth.getProject().id}`)
        .then(res => (this.cargas = res.data));
    },
    borrar: function() {
      if (this.$refs.eraserFrm.validate()) {
        this.eraser.loading = true;
        apiPython({
          //   "url": "http://45.79.39.42:8001/delete-data",
          url: "delete-data",
          method: "DELETE",
          data: {
            fecha_inicio: this.eraser.fecha_inicio,
            fecha_fin: this.eraser.fecha_fin,
            carga: this.eraser.carga
          }
        }).then(res => {
          this.eraser.loading = false;
          //   this.eraser.carga = null;
          //   this.eraser.fecha_inicio = null;
          //   this.eraser.fecha_fin = null;
          this.$refs.eraserFrm.reset();
          this.$awn.success(res.data.msg, {durations: {success: 0}});
        });
      }
    }
  }
});
</script>

<style>
</style>